// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon } from '../../../../dsl/front';
import { Screen } from '../../Screen';
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ArticleAction = class ArticleAction extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Determine if action is in progress.
         */
        this.isLoading = false;
    }
    /**
     * Determines whether there is any icon to render.
     */
    get hasIcon() {
        return typeof this.icon === 'string' && this.icon.length > 0;
    }
    /**
     * Determines whether there is any label to render.
     */
    get hasLabel() {
        return typeof this.label === 'string' && this.label.length > 0;
    }
    performAction() {
        const callbackReturn = this.callback();
        if (callbackReturn && typeof callbackReturn.then === 'function') {
            this.isLoading = true;
            callbackReturn.finally(() => {
                this.isLoading = false;
            });
        }
    }
};
__decorate([
    Prop({ type: Function, required: true })
], ArticleAction.prototype, "callback", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAction.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String, required: false })
], ArticleAction.prototype, "icon", void 0);
__decorate([
    Prop({ type: String, required: false })
], ArticleAction.prototype, "label", void 0);
ArticleAction = __decorate([
    Component({
        name: 'ArticleAction',
        components: { BootstrapButton, BootstrapIcon, Screen },
        template: `
    <Screen :loading="isLoading">
      <BootstrapButton class="article-action btn-link p-0" @click="performAction" v-bind="{ disabled }">
        <BootstrapIcon v-if="hasIcon" :name="icon" size="small"
                 class="article-action__icon me-1" />
        <span v-if="hasLabel" class="text-ui-separator-link">
          {{ label }}
        </span>
      </BootstrapButton>
    </Screen>
  `
    })
], ArticleAction);
export { ArticleAction };
export default ArticleAction;
